import { default as authenticatedRoutes } from './authenticatedRoutes';
import { default as publicRoutes } from './publicRoutes';
import { default as errorRoutes } from './errorRoutes';

export const ApplicationRoutes = [
  ...publicRoutes,
  ...authenticatedRoutes,
  ...errorRoutes,
];
